export class DocumentCollaborationBehavior {
  public isManageable: boolean;
}
